// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"600":"a451a711","889":"39f25425"}[chunkId] + ".chunk.js";
};